module.exports = __webpack_public_path__ + "img/mastercard.e5c65124.svg";